// ISP-9999 (stgport-education-category-discover-wheel-tags): mirrors the
// backend's WheelCategory TextChoices enum (yuga_wheel/models.py on
// DevOps-Staging-prod). Keep in sync if a slug is ever added/renamed there.
export const WHEEL_CATEGORY_OPTIONS = [
  { slug: "wellness", label: "Wellness" },
  { slug: "coaching", label: "Coaching" },
  { slug: "business", label: "Business" },
  { slug: "fitness", label: "Fitness" },
  { slug: "travel", label: "Travel" },
  { slug: "family", label: "Family" },
  { slug: "pets", label: "Pets" },
  { slug: "food", label: "Food" },
  { slug: "beauty", label: "Beauty" },
  { slug: "creative", label: "Creative" },
  { slug: "home", label: "Home" },
  { slug: "events", label: "Events" },
  { slug: "faith", label: "Faith" },
  { slug: "finance", label: "Finance" },
  { slug: "portfolio", label: "Portfolio" },
  { slug: "education", label: "Education" },
];

export const MAX_WHEEL_CATEGORIES = 5;
